/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { StatusResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class IntegrationManagementController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags integration-management-controller
   * @name Status
   * @request GET:/api/v1/document-fetcher/common/status
   */
  status = (params: RequestParams = {}) =>
    this.http.request<StatusResponse, any>({
      path: `/v1/document-fetcher/common/status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static statusPath = '/v1/document-fetcher/common/status'
  static statusMethod = 'GET'
  /**
   * No description
   *
   * @tags integration-management-controller
   * @name Disconnect2
   * @request DELETE:/api/v1/document-fetcher/common/{integrationName}
   */
  disconnect = (integrationName: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/document-fetcher/common/${integrationName}`,
      method: 'DELETE',
      ...params,
    })

  static disconnectPath = '/v1/document-fetcher/common/${integrationName}'
  static disconnectMethod = 'DELETE'
}
